import { IApplicationState } from '../../types/redux';

export const selectShortFormGroup = (state: IApplicationState): string | null => state.calculator.shortFormGroup;
